import React, { useEffect, useState } from 'react';
import StockLogo from './StockLogo';
import PriceChange from './PriceChange';
import MarketStatusBadge from './MarketStatusBadge';

function secondsAgoLabel(fetchedAt) {
  if (!fetchedAt) return '';
  const secs = Math.max(0, Math.round((Date.now() - new Date(fetchedAt).getTime()) / 1000));
  if (secs < 60) return `Updated ${secs}s ago`;
  return `Updated ${Math.round(secs / 60)}m ago`;
}

export default function StockHeader({ symbol, quote, profile }) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="stock-header">
      <StockLogo symbol={symbol} website={profile?.website} size={56} />
      <div className="stock-header-identity">
        <div className="stock-header-name-row">
          <h1>{quote?.shortName || symbol}</h1>
          <span className="ticker-pill">{symbol}</span>
        </div>
        <p className="input-hint">
          {quote?.exchange || 'Exchange unavailable'}
          {profile?.sector ? ` · ${profile.sector}` : ''}
        </p>
      </div>
      <div className="stock-header-price">
        {quote ? (
          <>
            <p className="stock-price">${quote.price?.toFixed(2)}</p>
            <PriceChange change={quote.change} changePercent={quote.changePercent} size="lg" />
            <div className="stock-header-meta">
              <MarketStatusBadge marketState={quote.marketState} />
              <span className="input-hint">{secondsAgoLabel(quote.fetchedAt)}</span>
            </div>
          </>
        ) : (
          <span className="skeleton-bar" style={{ width: 140 }} />
        )}
      </div>
    </div>
  );
}
